




























































import { Component, Vue } from "vue-property-decorator";
import UserAddModal from "./modals/userAddModal.vue";

@Component({
  components: { UserAddModal },
})
export default class UserManagement extends Vue {  
  isOpenUserFormModal: boolean = false;
  formModalKey: number = null;
  tableLoading: boolean = false;
  modalOpenType: number = null;
  selectedUser: any = {};
  requestList: any[] = [];
  headers: any[] = [];

  openModal(type : number ) {
    this.modalOpenType = type;
    this.isOpenUserFormModal = true;
    this.formModalKey = new Date().getTime();
  }
  closeModal() {
    this.getAgencyUsers();
    this.isOpenUserFormModal = false;
    this.formModalKey = new Date().getTime();
  }
  resetPassword(item) {
    this.selectedUser=item
    this.openModal(2);
  }
  updateUser(item) {
    this.selectedUser=item
    this.openModal(1);
  }
  async getAgencyUsers() {
    this.tableLoading = true;
    await this.$store.dispatch({
      type: "agencyUser/getAgencyUsers",
    });
    this.requestList = this.$store.state.agencyUser.list;
    this.tableLoading = false;
  }
  created() {
    this.getAgencyUsers();
    this.headers = [
      {
        text: "Acente",
        align: "start",
        filterable: false,
        value: "agency",
      },
      {
        text: "Ad - Soyad", value: "fullname",
      },
      { text: "E-posta", value: "emailAddress" },
      { text: "Telefon Numarası", value: "phoneNumber" },
      { text: "Oluştuma Tarihi", value: "creationTime" },
      { text: "Şifre", value: "password", align: "center" },
      { text: "Düzenle", value: "password", align: "center" },
    ];
  }

  data() {
    return {};
  }
}
